import { useEffect, useState } from "react";

import api from "./api";

const fallbackDrivers = [
  {
    user_id: 1,
    status: "approved",
    is_online: true,
    rating: 4.9,
    user: { email: "driver1@movigo.com", phone: "+306900000001" },
    vehicle: { make: "Toyota", model: "Corolla" },
  },
];

export default function useDrivers() {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchDrivers() {
      try {
        const response = await api.get("/admin/drivers");
        if (isMounted) {
          setDrivers(response.data.data?.drivers || response.data.drivers || []);
        }
      } catch (error) {
        if (isMounted) {
          setDrivers(fallbackDrivers);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchDrivers();

    return () => {
      isMounted = false;
    };
  }, []);

  return { drivers, loading };
}
